import { readCookie } from "utils/cookie";
import { AUTH_KEY } from "config/cookies";

export default function getUserFromCookie(req = null) {
  return JSON.parse(readCookie(AUTH_KEY, req) || "{}");
}
